import Vue from 'vue';
import Vuex from 'vuex';
import * as algoliasearch from 'algoliasearch';

export function initSearchClient() {
  const client = algoliasearch(
    process.env.VUE_APP_ALGOLIA_APP_ID,
    process.env.VUE_APP_ALGOLIA_API_KEY
  );
  Vue.prototype.$searchClient = client;
  Vuex.Store.prototype.$searchClient = client;
}
